
import { i18n } from '@/plugins/i18n';
import { DescriptionColumn } from '../components';
import Vue from 'vue';

const descriptionTemplate = (row, index, datatable) => {
    const Component = Vue.extend(DescriptionColumn);
    const instance = new Component({
        propsData: {
            row,
            index,
            datatable
        },
        i18n
    });

    instance.$mount(); // Mounts the component
    return instance.$el; // Returns the DOM element
};
export default [
    {
        field: 'id',
        width: 90,
        title: i18n.t('label.accounting_transaction_id'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        width: 90,
        title: i18n.t('label.amount'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'bank_name',
        width: 90,
        title: i18n.t('label.accounting_bank_name'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: "t_type_name",
        width: 90,
        title: i18n.t("label.type"),
        textAlign: 'center'
    },
    {
        field: "status",
        width: 50,
        title: i18n.t("label.status"),
        textAlign: 'center',
        template: (row) => {
            let variant, statusText;
            switch (row.status) {
                case 1:
                    variant = "bg-success";
                    statusText = i18n.t("accounting.status_ok");
                    break;
                case 2:
                    variant = "bg-danger";
                    statusText = i18n.t("accounting.status_need_consideration");
                    break;
                default:
                    variant = "bg-secondary";
                    statusText = i18n.t("unknown_status");
            }
            return `<div class="badge ${variant} text-white text-wrap">${statusText}</div>`;
        }
    },
    {
        field: 'recorded_at',
        title: i18n.t('label.date'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'description',
        width: 80,
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: true,
        textAlign: 'center',
    },
];